import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

/** Bootstrap import */
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/styles.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (window.location.ancestorOrigins.length === 0) {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  <p style={{ fontSize: '2rem', color: '#000' }}>Not allowed</p>
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
